<template>
    <div class="froalaEditor fr-view" id="froalaEditor"></div>
</template>

<script>
/**
 * Created by 邹美婷 on 2020/1/8.
 * 参考链接：https://www.froala.com/wysiwyg-editor/docs/options
 * 编辑器版本 v3.0.6
 * 
 */
import API from '@/fetch/api'
import { GetInfo } from '@/fetch/com'
var token = GetInfo("token");

export default {
    props: {

    },
    data(){
        return {
            m_editor: null,
        }
    },
    mounted(){
        this.initEditor();
    },
    methods: {
        initEditor(){
            let vm = this;
            vm.m_editor = new FroalaEditor('#froalaEditor', vm.configEditor());
        },

        /* 
        初始化编辑器配置
        @parmas{ width } 编辑器宽度，默认600
        @parmas{ height } 编辑器高度，默认200
        @parmas{ toolbars } 编辑器除了基本配置外增加的配置，默认见 toolbarButtons 配置
        */


        /*
         ---操作栏-----
        fullscreen  全屏
        selectAll  全选
        insertLink  超链接
        quote  引用
        insertHR  水平线
        subscript  下标
        superscript  上标
        undo   下一步
        redo   上一步
        bold  粗体
        italic  斜体
        underline 下划线
        strikeThrough  删除线
        fontFamily  字体
        fontSize   字体的大小
        inlineStyle  内联样式
        color   颜色
        paragraphFormat  段落格式
        paragraphStyle  段落样式
        align   对其方式
        formatOL   编号
        formatUL  项目符号
        outdent 减少缩进量
        indent  增加缩进量
        clearFormatting  清除格式
        inlineClass  内联类
        */


        configEditor(width, height, toolbars){
            let vm = this;
            toolbars = toolbars||[];
            return {
                toolbarSticky: false, //将工具栏保持在基本模式下的编辑框顶部。禁用此选项，向下滚动时，工具栏将保持在页面顶部
                // width: width || 600,
                heightMin: height || 400,
                heightMax: 400,
                autosave: true, //是否自动保存
				useClasses: true, 
                placeholderText: '请输入', // placeholder
                // pastePlain: true,//'将内容粘贴到富文本编辑器时删除文本格式',但保留内容的结构。
                pasteAllowLocalImages: true,
                imagePaste: true, 
                // 工具栏配置
                toolbarButtons:   {
                    moreText: {
                        buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'clearFormatting'],
                        align: 'left',
                        buttonsVisible: 3
                    },
                    moreParagraph: {
                        buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent'],
                        align: 'left',
                        buttonsVisible: 3
                    },
                    moreRich: {
                        buttons: ['insertLink', 'insertImage', 'insertVideo','insertTable', 'fontAwesome', 'embedly', 'insertFile'],
                        align: 'left',
                        buttonsVisible: 3
                    },
                    moreMisc: {
                        buttons: ['undo', 'redo', 'fullscreen', 'help'],
                        align: 'right',
                        buttonsVisible: 2
                    }
                },
                videoInsertButtons: ["videoBack", "|", "videoUpload"],
                imageInsertButtons: ["imageBack", "|", "imageUpload", "imageByURL"],
                linkInsertButtons: ['linkBack', '|', 'linkList'],
                quickInsertButtons: ['image', 'table', 'ul', 'ol', 'hr'],//快速插入控件配置
                linkText: false,
                // 上传配置
                requestHeaders: {
                    'Accept': '*/*',
                    'Authorization': 'Bearer ' + token
                },
                requestWithCORS: true, 

                /* 上传图片配置 */
                imageUploadURL: API.UpFileUriString(),
                imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif'],
                imageMaxSize: 1024 * 1024 * 5,
                imageUploadParam: 'uploadFile', // 上传图片，入参
                imageDefaultAlign: 'center', //图片插入时，默认左对齐
                imageDefaultDisplay: 'block', //图片插入时，默认行内排列
                
                /* 文件上传配置 */
                fileUploadURL: API.UpFileUriString(),
                fileMaxSize: 1024 * 1024 * 10,
                fileUploadParam: 'uploadFile', // 上传入参
                fileAllowedTypes: [
                    'application/pdf', 
                    'application/msword', 
                    'application/msexcel',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'application/vnd.ms-excel', 
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                ],

                /* 上传视频配置 */
                videoUploadURL: API.UpFileUriString(),
                videoMaxSize: 1024 * 1024 * 30,
                videoUploadParam: 'uploadFile', // 上传图片，入参
                videoAllowedTypes: ['mp4', 'webm', 'ogg'],
                videoDefaultDisplay: 'block',
                videoDefaultAlign: 'center',
                videoDefaultWidth: '100%',
                // fontFamilySelection: true,//编辑器工具栏中的字体系列按钮将替换为显示当前文本选择的实际字体系列名称的下拉列表。
                // fontSizeSelection: true,//编辑器工具栏中的字体大小按钮将替换为显示当前文本选择的实际字体大小值的下拉列表。
                // paragraphFormatSelection: true,//编辑器工具栏中的段落格式按钮将替换为显示当前文本选择的实际段落格式名称的下拉列表。
                toolbarStickyOffset: 20,//粘滞工具栏从页面顶部的偏移量。
                // tableInsertHelper:false,//通过转到表格的边缘可以更轻松地插入行和列。
                tableResizerOffset: 10 ,//与表格单元的左侧或右侧边框之间的距离，以像素为单位显示调整器。
               pasteAllowedStyleProps: ['font-size', 'color', 'width', 'font-family', 'height'],
                /*  imageDefaultWidth: 0,
                imageEditButtons:["imageReplace","imageAlign","imageCaption","imageRemove","|","imageLink","linkOpen","linkEdit","linkRemove","-","imageDisplay","imageAlt","imageSize"],
                toolbarButtons: ['fullscreen', '|', 'selectAll','insertLink','|', 'quote', 'insertHR', 'subscript', 'superscript', 'undo', 'redo', '-', 'bold', 'italic', 'underline', 'strikeThrough', '|', 'fontFamily', '|', 'fontSize', '|', 'color', 'inlineStyle', '-', 'paragraphFormat', '|', 'paragraphStyle', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'clearFormatting'].concat(toolbars),
                pluginsEnabled: ['align','charCounter','codeBeautifier','codeView','colors','draggable','embedly','emoticons','entities','fontFamily','fontSize','fullscreen','image','imageManager','inlineStyle','lineBreaker','link','lists','paragraphFormat','paragraphStyle','quote','save','table','url','wordPaste'],
                
                tableEditButtons:[ 'tableRows','tableColumns','tableCells','tableCellVerticalAlign','tableRemove' ,'tableCellBackground','tableHeader','cell'], */
                language: 'zh_cn',
                events: {
                    // 上传图片出错
                    /* 
                    1	无法通过传递的链接加载图片。	传递的链接不正确或文件不是图像。
                    2	上传响应中没有链接。	HTTP请求上传图片的响应不正确。回复不遵守imageUploadURLOption 的指示。
                    3	文件上传期间出错。	
                    4	解析响应失败。	
                    5	文件太大。	
                    6	图像文件类型无效。	
                    7	文件只能上传到IE 8和IE 9中的同一域。
 */
                    'image.error': (err)=>{
                        let msg = '上传图片失败，请重试！';
                        if(err.code == 5){
                            msg = '上传图片不能超过5M';
                        }else if(err.code == 6){
                            msg = '仅支持jpeg/jpg/png/gif等图片格式上传';
                        }
                        vm.$showAlert(msg, "warning")
                    },
                    'file.beforeUpload': (file)=>{
                        let fileAllowedTypes = ['xlsx', 'xls', 'doc', 'docx', 'pdf'];
                        if(!file[0].name) {
                            vm.$showAlert('上传文件失败，请重试！', "warning");
                            return false;
                        };
                        
                        let type = file[0].name.substring(file[0].name.lastIndexOf('.')+1);
                        if(fileAllowedTypes.indexOf(type) == -1){
                            vm.$showAlert('仅支持pdf、word、excel等文件格式上传', "warning");
                            return false;
                        }
                    },
                    'file.error': (err, res)=>{
                        let msg = '上传文件失败，请重试！';
                        if(err.code == 5){
                            msg = '上传图片不能超过10M';
                        }else if(err.code == 6){
                            msg = '仅支持pdf、word、excel等文件格式上传';
                        }
                        vm.$showAlert(msg, "warning")
                    },
                    'video.error': (err, res)=>{
                        let msg = '上传视频失败，请重试！';
                        if(err.code == 5){
                            msg = '上传视频不能超过30M';
                        }else if(err.code == 6){
                            msg = '仅支持mp4/webm/ogg等视频格式上传';
                        }
                        vm.$showAlert(msg, "warning")
                    },

                }
            }
        },
        getHTML(){
            return this.m_editor.html.get(true);
        },
        getText(){
            return this.m_editor.html.get(false);
        },
        setHTML(val){
            this.m_editor.html.set(val);
            this.m_editor.events.trigger("charCounter.update");
        }
    }
}
</script>

<style lang="scss">
    .froalaEditor{
        ol{
            list-style: decimal;
            li{
                list-style-type: inherit;
            }
        }
        ul{
            list-style: disc;
            li{
                list-style-type: inherit;
            }
        }
    }
</style>
